import { Link, useLocation } from "react-router-dom";
import { BookOpenText } from "@phosphor-icons/react";
import { TOOLS } from "@/lib/tools";

// Map each tool's editor/view URL first-segment -> tool type, derived from the registry.
const SEG_TO_TOOL = {};
Object.values(TOOLS).forEach((t) => {
  ["editor", "view"].forEach((k) => {
    const seg = t.routes[k]("_").split("/")[1];
    if (seg) SEG_TO_TOOL[seg] = t.type;
  });
});

// Contextual "How & Why" affordance shown at the top of any tool editor/view.
// Renders nothing on non-tool routes so it never clutters other pages.
export default function GuideLink() {
  const { pathname } = useLocation();
  const toolType = SEG_TO_TOOL[pathname.split("/")[1]];
  if (!toolType) return null;
  return (
    <div className="max-w-7xl mx-auto px-6 lg:px-10 pt-5 flex justify-end print:hidden">
      <Link
        to={`/guide/${toolType}`}
        data-testid="guide-link"
        className="inline-flex items-center gap-1.5 rounded-sm border border-slate-200 bg-white px-3 py-1.5 text-xs font-mono uppercase tracking-wide text-slate-500 hover:text-slate-900 hover:border-slate-300 transition-colors"
      >
        <BookOpenText size={15} weight="duotone" /> How &amp; Why
      </Link>
    </div>
  );
}
